import React from 'react';
import soon from '../../../images/coming-soon.jpg'
const Payment = () => {
    return (
        <div>
            <h2 className="my-5 mt-5">Payment System Coming Soon</h2>
            <img className='rounded mb-2' src={soon} alt="" />
        </div>
    );
};

export default Payment;